import React from 'react'
import Header from '../../component/layout/header'
import { Outlet } from 'react-router'
import useNav from '../../component/custom-hooks/get-nav'

const ElectricityConfigLayout = () => {
  const navList = useNav();
  let { electricityConfigBottom, electricityConfigTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={electricityConfigBottom} topTabs={electricityConfigTopHeader} />
      <Outlet />
    </div>
  )
}

export default ElectricityConfigLayout
